import { render, staticRenderFns } from "./IInstitucional.vue?vue&type=template&id=74b26f76&scoped=true&"
var script = {}
import style0 from "./IInstitucional.vue?vue&type=style&index=0&id=74b26f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b26f76",
  null
  
)

export default component.exports